module.exports = __webpack_public_path__ + "img/ticket.813c80a2.svg";